import axios from 'axios'
import CreateCode from './dto/CreateCode'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedCodeResultRequestDto} from './dto/PagedCodeResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllCodes from './dto/GetAllCodes'
import UpdateCode from './dto/UpdateCode'
import GetCode from './dto/GetCode'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Code/Create`
export const URL_DELETE = `${API_URL}/Code/Delete`
export const URL_GET = `${API_URL}/Code/Get`
export const URL_GET_ALL = `${API_URL}/Code/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Code/Update`

export function onCreateCode(createCode: CreateCode): Promise<boolean> {
  return axios.post(URL_CREATE, createCode)
}

export function onDeleteCode(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetCode(entityDto: EntityDto): Promise<GetCode> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllCodes(
  pagedFilterAndSortedRequest: PagedCodeResultRequestDto
): Promise<PagedResultDto<GetAllCodes>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateCode(updateCodeInput: UpdateCode): Promise<boolean> {
  return axios.put(URL_UPDATE, updateCodeInput)
}
